module.exports = __webpack_public_path__ + "media/images/preview-b8bab5cc4c0054824fbc21397cbe0ef3.png";